export default __webpack_public_path__ + "static/media/sign-up-background.7540d357.png";